module.exports = __webpack_public_path__ + "static/media/dotfull.865ef039.svg";